var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.405,
    height: 24.409,
    viewBox: "0 0 24.405 24.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.85 -1.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.953,13.495a.38.38,0,0,0-.342-.052l-2.9.973L21.368,2.337A.376.376,0,0,0,20.993,2H17.405a.379.379,0,0,0-.375.337L15.706,14.188,12.375,15.2,11.335,5.887a.376.376,0,0,0-.375-.337H8.255a.379.379,0,0,0-.375.337l-.968,8.676L2.247,16.276A.38.38,0,0,0,2,16.632v9.1a.376.376,0,0,0,.375.375H25.73a.376.376,0,0,0,.375-.375V13.8A.346.346,0,0,0,25.953,13.495Zm-5.3-10.74.18,1.623H17.557l.18-1.623ZM16.494,13.946l.982-8.813h3.446l1.063,9.525-3.332,1.115V13.8a.365.365,0,0,0-.294-.365.1.1,0,0,0-.038,0c-.014,0-.028,0-.043,0a.4.4,0,0,0-.109.014ZM10.623,6.3l.114,1.039H8.473L8.587,6.3ZM8.393,8.094h2.43l.816,7.328-1.2.365V13.8a.38.38,0,0,0-.161-.308.591.591,0,0,0-.095-.047c-.009,0-.019,0-.028-.009a.369.369,0,0,0-.076-.009s-.009,0-.019,0a.017.017,0,0,0-.014,0,.345.345,0,0,0-.119.019L7.7,14.264ZM25.355,25.355H2.755V16.893l6.939-2.553V16.3a.365.365,0,0,0,.294.365.1.1,0,0,0,.038,0c.014,0,.028,0,.043,0a.4.4,0,0,0,.109-.014L17.9,14.306V16.3a.361.361,0,0,0,.157.3.356.356,0,0,0,.095.047c.009,0,.024,0,.033.009a.366.366,0,0,0,.071.009c.009,0,.014,0,.024,0h.014a.271.271,0,0,0,.1-.019h0l6.958-2.335Z",
    transform: "translate(-2 -2)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.662,385.7H56.775a.376.376,0,0,0-.375.375V388.8a.373.373,0,0,0,.375.375h3.882a.376.376,0,0,0,.375-.375v-2.724A.369.369,0,0,0,60.662,385.7Zm-.38,2.724H57.15V386.45h3.132Z",
    transform: "translate(-53.818 -367.49)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.457,385.7h-3.882a.376.376,0,0,0-.375.375V388.8a.376.376,0,0,0,.375.375h3.882a.376.376,0,0,0,.375-.375v-2.724A.373.373,0,0,0,211.457,385.7Zm-.375,2.724H207.95V386.45h3.132Z",
    transform: "translate(-197.461 -367.49)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.275,385.7a.376.376,0,0,0-.375.375V388.8a.376.376,0,0,0,.375.375h3.882a.376.376,0,0,0,.375-.375v-2.724a.376.376,0,0,0-.375-.375Zm3.507,2.724H358.65V386.45h3.132Z",
    transform: "translate(-341.009 -367.49)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.8e119f6c.svg";
export { ForwardRef as ReactComponent };